import { createIcon } from '../create-icon'

export const GameController = createIcon('GameController', ({ strokeWidth }) => (
  <>
    <path
      d="M6 11h4M8 9v4"
      strokeWidth={strokeWidth}
    />
    <line x1="15" y1="12" x2="15.01" y2="12" strokeWidth={strokeWidth} />
    <line x1="18" y1="10" x2="18.01" y2="10" strokeWidth={strokeWidth} />
    <path
      d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1.3 0 1.88-.81 2.54-1.82L9.06 15h5.88l1.52 2.18C17.12 18.19 17.7 19 19 19a3 3 0 0 0 3-3c0-1.544-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.152A4 4 0 0 0 17.32 5Z"
      strokeWidth={strokeWidth}
    />
  </>
))
